import { useState } from "react";
import styles from "./Courses.module.css";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { courses } from "../../Constants/HeaderConstants";
import newBadgeStar from "../../resources/images/courses-dropdown/newBadgeStar.svg";
import doubtResolutionDot from "../../resources/images/courses-dropdown/doubtResolutionDot.svg";

const Courses = ({ isMobileCerti = false }) => {
  const [open, isOpen] = useState(false);

  const disableScroll = () => {
    document.body.style.overflow = "hidden";
  };

  const enableScroll = () => {
    document.body.style.overflow = "auto";
  };

  const arrowStyle = {
    transition: "transform 0.3s ease",
    transformOrigin: "center",
    transform: open ? "rotate(180deg)" : "rotate(90deg)",
  };

  return (
    <div
      className={styles.certificationContainer}
      onClick={
        isMobileCerti
          ? () => {
              isOpen((prevState) => !prevState);
            }
          : null
      }
      onMouseEnter={!isMobileCerti ? disableScroll : null}
      onMouseLeave={!isMobileCerti ? enableScroll : null}
    >
      <div className={styles.certificationText}>
        <div className={styles.certificationDiv}>
          <div className={styles.certificationCoursesTitleArrow}>
            <div className={styles.certificationCoursesTitle}>Courses</div>
            <KeyboardArrowUpIcon
              className={!isMobileCerti ? styles.arrowKeyStyle : null}
              style={isMobileCerti ? arrowStyle : null}
            />
          </div>
          <div className={styles.skillsLink}>Interview Preparations</div>
        </div>
      </div>
      <div
        className={`${styles.hoverBox} ${open ? styles.hoverBoxOpen : ""}`}
        onMouseEnter={!isMobileCerti ? disableScroll : null}
        onMouseLeave={!isMobileCerti ? enableScroll : null}
      >
        <div className={styles.doubtHeading}>
          <img src={doubtResolutionDot} alt="" className={styles.doubtIcon} />
          <p>Doubt resolution included in all the Certifications</p>
        </div>

        <div className={styles.courseItemContainer}>
          {courses.map((course) => (
            <div
              key={course.id}
              className={styles.courseItem}
              onClick={(e) => {
                e.stopPropagation();
                window.open(`${course.link}`, "_blank");
              }}
            >
              <div className={styles.iconWrapper}>
                <img
                  src={course.icon}
                  alt={course.name}
                  className={styles.icon}
                />
              </div>
              <div className={styles.courseTextGroup}>
                <div className={styles.courseNameRow}>
                  <p className={styles.coursepara}>{course.name}</p>
                  {course.badge && (
                    <span className={styles.badge}>
                      <img src={newBadgeStar} alt="" className={styles.badgeStar} />
                      {course.badge}
                    </span>
                  )}
                </div>
                <p className={styles.courseSubtitle}>{course.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Courses;
